import { createContext, Dispatch, SetStateAction } from "react";

import { noop, ViewDto } from "@ryde/shared";

interface IViewContext {
  isEditViewOpen: boolean;
  openEditView: (viewDto?: ViewDto) => void;
  editView: ViewDto | undefined;
  isDropdownOpen: boolean;
  setIsDropdownOpen?: Dispatch<SetStateAction<boolean>>;
}

export const ViewContext = createContext<IViewContext>({
  isEditViewOpen: false,
  editView: undefined,
  openEditView: noop,
  isDropdownOpen: false,
});
